<div class="backgroundDark">
    <h2 mat-dialog-title class="marginBottom0" fxFlex>{{title}}</h2>
</div>

<mat-dialog-content style="max-height: 95%; padding: 0 !important;">
    <div fxLayout="column">
        <div fxLayout="row" fxFlex="100%">
            <div class="unsavedChangesText" [innerHTML]="content"></div>
        </div>
        <div fxLayout="row" fxFlex="100%" style="height: 45px;">
            <div class="unsavedChangesText">Are you sure you would like to continue?</div>

        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions fxLayoutAlign="end center">   
    <button mat-button matDialogClose="cancel" class="mat-raised-button dialogActionButton">No</button>
    <button mat-button matDialogClose="confirm" color="primary" class="mat-raised-button dialogActionButton">Yes</button>
</mat-dialog-actions>
